import { render, staticRenderFns } from "./BeeList.vue?vue&type=template&id=02987048"
import script from "./BeeList.vue?vue&type=script&lang=js"
export * from "./BeeList.vue?vue&type=script&lang=js"
import style0 from "./BeeList.vue?vue&type=style&index=0&id=02987048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports